import { apiRequest } from '@/utils/api-request';
import { OrgNodeAccessConfig } from './get-org-node-access-config';

export const updateCapitolConfig = async (
  orgId: string,
  items: Record<string, boolean>,
): Promise<OrgNodeAccessConfig> => {
  const response = await apiRequest<OrgNodeAccessConfig>({
    url: `/org-node-access-config/${orgId}/capitol`,
    method: 'PATCH',
    target: 'platform',
    body: { items },
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return response?.data || { orgid: orgId, items: {} };
};
